import { render, staticRenderFns } from "./MyFilesTable.vue?vue&type=template&id=3fb6835e&scoped=true&"
import script from "./MyFilesTable.vue?vue&type=script&lang=js&"
export * from "./MyFilesTable.vue?vue&type=script&lang=js&"
import style0 from "./MyFilesTable.vue?vue&type=style&index=0&id=3fb6835e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb6835e",
  null
  
)

export default component.exports